export default __webpack_public_path__ + "images/74590416848c19af95a3b23a8ca726ac.svg";